import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../Services/shared.service';
import { HTTPAPIConfig, VlDataService, VlHttpService, APIConfigMapping, ImageCropperComponent, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS, StreamBlobService } from 'shared-library';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from "@angular/material/dialog";
import { Subject, takeUntil } from 'rxjs';
import { MediaComponent } from '../media/media.component';

@Component({
  selector: 'lib-mobilesettings',
  templateUrl: './mobilesettings.component.html',
  styleUrls: ['./mobilesettings.component.scss']
})
export class MobilesettingsComponent implements OnInit,OnDestroy{
  
@ViewChild('imageRef') imageRef!: ElementRef<HTMLImageElement>;
  
applicationId!:string;
applicationData:any = {};
biometrics:boolean = false;
offlineMode:boolean = false;
migrationEnabled:boolean = false;
showImageLengthError:boolean = false;
selectedImage!:File | any;
imageSrc!:any;
blobName!:any;
blobUrl:any = null;
imageS3Key:any;
timeStampEnabled:boolean=false;
lastModifiedDate:any;
applicationForm!:FormGroup;
loading:boolean = true;
fetching:boolean = false;
  private destroy$ = new Subject<void>();

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  constructor(private sharedService:SharedService, private dataService: VlDataService,private toaster:ToastrService,private dialog:MatDialog,private httpService: VlHttpService, private route: ActivatedRoute,private _formBuilder:FormBuilder,private streamBlobService:StreamBlobService){
    
  }
  ngOnInit(): void {
    
    this.buildForm()
    this.subscribeEvents();
    this.getApplicationById(this.applicationId);
  }

  ngAfterViewInit() {
      this.adjustSpinnerSize();
  }

  adjustSpinnerSize() {
    if(this.imageRef){
      const img = this.imageRef.nativeElement;
      if (img) {
        img.onload = () => this.loading = false;
      }
    }
  }

  buildForm(){
    this.applicationForm = this._formBuilder.group({
      applicationName:[,Validators.required],
      applicationDescription:[]
    })
  }

  subscribeEvents(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.applicationId=params?.['id']
    })
  }



  getApplicationById(id:string){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_APPLICATION']);
    apiConfig.postData = {
      id: id
    }
    apiConfig.options = {
      params: {
        "is_web":"true",
      }
    }
    this.fetching = true;
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.sharedService.setApplicationDataEntire(data);
       this.setApplicationDetails(data);
       this.fetching = false;
      },
      error: (err: any) => {
        this.fetching = false;
        if(err?.status == 403) {
          this.toaster.error('You do not have permission to access this resource.');
        }
      }
    })
  }

  setApplicationDetails(applicationData:any){
    this.applicationData = applicationData;
    if(applicationData?.blob_name){
      this.streamImage(applicationData?.blob_name);
    }
    this.applicationForm.patchValue({
      applicationName: applicationData.application_name,
      applicationDescription: applicationData.application_description
    })
    this.biometrics = applicationData.biometric;
    this.loading = true;
    this.imageSrc = applicationData?.image;
    this.updateImageUrl();
    this.imageS3Key = applicationData?.image
    this.timeStampEnabled=true;
    this.lastModifiedDate=applicationData?.last_modified_date
    if (applicationData?.settings) {
      this.offlineMode = applicationData?.settings['offline'] ?? false;
      this.migrationEnabled = applicationData?.settings['app_migration_enable'] ?? false;
    }else{
      this.offlineMode = false;
      this.applicationData['settings'] = {'offline' :false}
    }

  }

  async streamImage(blobName:string){
      this.blobUrl = await this.streamBlobService.fetchImage(blobName);
  }


  updateImageUrl() {
    // Create a new URL with timestamp or version
    const newImageUrl = `${this.imageSrc}?v=${new Date().getTime()}`;
    
    // Sanitize the URL to prevent security issues
    this.imageSrc = newImageUrl;
  }

  onToggleChange(event:any,isMigration?:boolean){
    if(isMigration){
      this.migrationEnabled = event.checked;
    }else{
      this.offlineMode = event.checked;
    }
  }

  onFileSelected(event: any) {
    this.timeStampEnabled=false;
    const selectedFile = event.target.files[0];
  
    if (selectedFile) {
     this.openCropper(selectedFile);
    }
  }
  
  editApplication(applicationName:string,applicationDescription:string,applicationIcon:File,applicationId:string,biometrics:boolean,applogo:string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_APPLICATION']);
    let userInfoString: any = localStorage.getItem('userInfo');
    if (userInfoString !== null) {
      // Parse the JSON string to an object
      const userInfo = JSON.parse(userInfoString);
    
      // Access the userId property
      const userId = userInfo.userId;
    }
    apiConfig.postData = {
      application_id: applicationId,
      application_name: applicationName,
      application_description: applicationDescription,
      biometric: biometrics,
      image:applogo,
      blob_name: this.blobName ?? '',
      last_modified_by:"User2",
      settings:{
        offline: this.offlineMode,
        app_migration_enable:this.migrationEnabled
      }
    }
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        const applicationData = this.sharedService.getApplicationDataEntire();
        applicationData.application_description = applicationDescription;
        applicationData.application_name = applicationName;
        applicationData.biometric = biometrics;
        applicationData.settings = {
          offline: this.offlineMode,
          app_migration_enable: this.migrationEnabled
        };
        applicationData.image = applogo;
        this.sharedService.setApplicationDataEntire(applicationData);   
        this.sharedService.setApplicationData(data);
        if(this.selectedImage == null){
          this.toaster.success("Changes Successfully Applied");
        }
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toaster.error('You do not have permission to access this resource.');
        }else{
          this.toaster.error(err.error.result);
        }
      }
    })
  }


  onSaveClick(){
    const applicationFormData = this.applicationForm.getRawValue();
    const hasApplicationDataChanged =   this.applicationData.application_name !== applicationFormData.applicationName ||
    this.applicationData.application_description !== applicationFormData.applicationDescription ||
    this.applicationData.biometric !== this.biometrics || this.offlineMode !== this.applicationData?.settings['offline'] || this.imageSrc.split('?')[0] !== this.applicationData?.image;

    if(hasApplicationDataChanged){
      this.editApplication(applicationFormData.applicationName,applicationFormData.applicationDescription,this.selectedImage,this.applicationId,this.biometrics,this.imageSrc.split('?')[0]);
      const existBreadcrumb = this.sharedService.getCurrentBreadcrumb();
        if(existBreadcrumb.length > 2){
          const newExitsBreadcrumb  = existBreadcrumb.slice(0,2);
          this.sharedService.updateBreadcrumb(newExitsBreadcrumb);
        }
       
        const currentBreadcrumb = this.sharedService.getCurrentBreadcrumb();
        const newBreadcrumbObj = { id: this.applicationId, label: applicationFormData.applicationName, state: 'mobile' };
        const newBreadcrumb = [...currentBreadcrumb, newBreadcrumbObj];
        this.sharedService.updateBreadcrumb(newBreadcrumb);
      this.sharedService.updateApplicationName(applicationFormData.applicationName);
    }

  }

  openCropper(selectedimage:File){
    const dialogRef =  this.dialog.open(ImageCropperComponent,{
       disableClose: true,
       data: {
        imageFile:selectedimage
      }
    })

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

      if (typeof (result) !== 'boolean' && result !== undefined) {
        
        this.imageSrc = result.croppedImageUrl,
        this.selectedImage = result.croppedImageFile
      }
    });
  }

  openMediaPopUp(event:any){
      const dialogRef =  this.dialog.open(MediaComponent,{
          height: '80vh',
          width: '90vw',
          autoFocus: false,
          data:{
            image:this.imageSrc.split("?")[0] ?? this.imageSrc,
            blobName:this.applicationData?.blob_name ?? null
          }
        })
  
      dialogRef.afterClosed().subscribe(async (result:any) => {
        if (result?.proceed) {
          this.loading = true;
          this.imageSrc = result.image.resource_url;
          this.blobName = result.image.resource_blob;
          this.streamImage(this.blobName);
        }
      });
  
    }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}